let IsDevEnvironment = window.location.host.toLowerCase().indexOf("localhost") > -1 || window.location.host.toLowerCase().indexOf("certificationdev.testout.com") > -1;

//@ts-ignore
let LabSimAPIUrl = IsDevEnvironment ? process.env.REACT_APP_LABSIMAPI_URL_DEV : process.env.REACT_APP_LABSIMAPI_URL_PROD;

export { IsDevEnvironment, LabSimAPIUrl }